import { Contract } from "appworks/utils/contracts/contract";
import { AnimateSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";

export class PYLWhammyLandSymbolBehavior extends AnimateSymbolBehaviour {
    public land(): Contract<void> {
        return this.animate("_win", [this.defaultAnimation], false, true);
    }
}